import { ApiEndPoint } from './apiEndPoint'

export const globalSearch = new ApiEndPoint('search/global')